<template lang="pug">
v-content
  v-dialog(v-model="show_video" width="75vw")
    v-responsive(:aspect-ratio="16/9" v-if="current_video" :key="current_video")
      iframe(width="100%" height="100%" :src="`https://www.youtube.com/embed/${current_video}`" frameborder="0" allow="encrypted-media;" allowfullscreen)
  v-tabs(v-model="tab" centered grow)
    v-tab(v-for="p in playlists" :key="p.name") {{ p.name }}
  v-tabs-items(v-model="tab")
    v-tab-item(v-for="p in playlists" :key="p.name")
      v-container
        v-row(align="center" justify="center")
          v-col(cols=12 md=6 lg=4 v-for="v in p.videos" :key="v.id")
            v-card(hover @click="current_video = v.id; show_video = true")
              v-img(:src="v.thumb" :aspect-ratio="16/9" gradient="to bottom, rgba(0, 0, 0, 0.7), transparent 100px")
                h3.title.ml-3.mt-2 {{ v.title }}
</template>

<script>
import axios from 'axios'

export default {
  name: 'Video',
  data() {
    return {
      tab: null,
      show_video: null,
      current_video: null,
      playlists: [
        {
          id: 'PLqM5ucxGNnqeua80PjDKMnc6iLUXMtNDX',
          name: 'Обучающие видео',
          videos: [],
        },
        {
          id: 'PLqM5ucxGNnqd3Lz3wZal7pios5e8ffLE0',
          name: 'Обучающие мультфильмы',
          videos: [],
        },
        {
          id: 'PLqM5ucxGNnqdtWONT9obqdrexHvzTUUSE',
          name: 'Караоке',
          videos: [],
        },
        {
          id: 'PLqM5ucxGNnqefYJTj2NejlaOa73ghdicW',
          name: 'Физкультминутки',
          videos: [],
        },
        {
          id: 'PLqM5ucxGNnqeLgJTzzKdo5tOtbYi6mwfi',
          name: 'Шишкина школа',
          videos: [],
        },
      ],
    }
  },
  computed: {},
  methods: {
    async getPlaylistVideos() {
      for (let p of this.playlists) {
        let videos = []
        let pageToken = true
        while (pageToken) {
          let resp = await axios.get(`https://www.googleapis.com/youtube/v3/playlistItems`, {
              params: {
                playlistId: p.id,
                maxResults: 50,
                pageToken: pageToken == true ? null : pageToken,
                part: 'contentDetails,snippet',
                fields: 'items(snippet(title,thumbnails),contentDetails/videoId),nextPageToken',
                key: 'AIzaSyDczAWznIR_qrc3mbu-RBsdgC4PlosS4UE',
              },
            })
          pageToken = resp.data.nextPageToken
          videos = videos.concat(resp.data.items)
        }
        
        p.videos = videos
          .filter((x) => Object.keys(x.snippet.thumbnails).length > 0)
          .map((x) => ({
            title: x.snippet.title,
            id: x.contentDetails.videoId,
            thumb: x.snippet.thumbnails.standard ? x.snippet.thumbnails.standard.url : x.snippet.thumbnails.high.url,
          }))
      }
    },
  },
  mounted() {
    let today = new Date().getDate()
    if (localStorage.last_videos_update && localStorage.playlists && localStorage.last_videos_update == today) {
      this.playlists = JSON.parse(localStorage.playlists)
    } else {
      this.getPlaylistVideos().then(() => {
        localStorage.last_videos_update = today
        localStorage.playlists = JSON.stringify(this.playlists)
      })
    }
  },
}
</script>